import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import AdminNav from "./components/feature/AdminNav";
import ChatNudgeBar from "./components/feature/ChatNudgeBar";
import { useChatLeadBridge } from "./hooks/useChatLeadBridge";

function AppInner() {
  useChatLeadBridge();
  return (
    <>
      <AppRoutes />
      <AdminNav />
      <ChatNudgeBar />
    </>
  );
}

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AppInner />
    </BrowserRouter>
  );
}

export default App;
